import React, { useCallback, useEffect, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { useAppSelector, useTranslation } from '@hooks';
import NoDataBlock from '../Components/NoDataBlock';
import Charts from '@components/Charts/Highcharts';

const CHART_OPTIONS = {
    chart: {
        backgroundColor: null,
        type: 'pie',
        plotShadow: false,
        margin: 2,
    },
    title: {
        text: null,
    },
    plotOptions: {
        pie: {
            dataLabels: {
                enabled: false,
            },
            showInLegend: true,
        },
    },
    legend: {
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'middle',
        itemMarginTop: 3,
        itemMarginBottom: 3,
        symbolRadius: 0,
        itemHiddenStyle: {
            color: '#77777C',
        },
        itemHoverStyle: {
            color: null,
        },
        itemStyle: {
            color: 'black',
        },
    },
    series: [
        {
            name: 'Count',
            keys: ['name', 'y'],
            data: [['', 0]],
        },
    ],
    credits: false,
};

const IotItemCountStatusChart = ({ data, settings }) => {
    const t = useTranslation('IotItemCountStatus');
    const { colorScheme } = useAppSelector(state => state.ThemeOptions);
    const [chartOptions, setChartOptions] = useState(CHART_OPTIONS);
    const [containerProps, setContainerProps] = useState({
        style: {
            width: 0,
            height: 0,
        },
    });

    useEffect(() => {
        setChartOptions(prevState => ({
            ...prevState,
            pie: {
                ...prevState.pie,
                innerSize: settings.chartType === 'doughnut' ? '50%' : 0,
            },
            legend: {
                ...prevState.legend,
                itemStyle: {
                    color: colorScheme === 'pnt-dark' ? 'white' : 'black',
                },
            },
        }));
    }, [colorScheme, settings]);

    useEffect(() => {
        setChartOptions(prevState => ({
            ...prevState,
            series: [
                {
                    name: t('Count'),
                    keys: ['name', 'y'],
                    data: data.map(status => [status.name, status.value]),
                },
            ],
        }));
    }, [data, t]);

    const onResize = useCallback((width, height) => {
        setContainerProps({
            style: {
                width,
                height,
            },
        });
    }, []);

    return (
        <>
            {!data.length ? (
                <NoDataBlock />
            ) : (
                <ReactResizeDetector
                    refreshMode="debounce"
                    refreshRate={100}
                    handleHeight
                    handleWidth
                    onResize={onResize}
                >
                    <Charts reflowDeps={[containerProps]} containerProps={containerProps} options={chartOptions} />
                </ReactResizeDetector>
            )}
        </>
    );
};

export default IotItemCountStatusChart;
